import React, { useEffect, useState } from 'react';
import { ClientPrivate } from '../model/Client';
import { PlanningSlot } from '../model/Planning';
import { getClientHistory } from '../services/service';
import { splitHistory } from '../utils';
import { Image } from './Image';
import { PlanningSlotViewer } from './PlanningSlotViewer';

export interface ClientProps {
  client: ClientPrivate;
}

export const ClientComponent: React.FC<ClientProps> = ({ client }) => {
  const [slots, setSlots] = useState<PlanningSlot[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const get = async () => {
      setSlots(await getClientHistory(client.client.id));
      setLoading(false);
    };

    get();
  }, [client.client.id]);

  const split = splitHistory(slots);

  return (
    <div className="page-stack">
      <section className="detail-grid one-col-left">
        <article className="panel">
          <Image isClient={true} id={client.client.id} />
          <h3>Profil client</h3>
          <div className="info-list">
            <div><b>Nom:</b> {client.client.lastname}</div>
            <div><b>Prenom:</b> {client.client.firstname}</div>
            <div><b>Telephone:</b> {client.client.phoneNumber}</div>
            <div><b>Email:</b> {client.email}</div>
            <div><b>Adresse:</b> {client.address.description}</div>
          </div>
        </article>
      </section>

      <section className="panel">
        <h3>Prochaines seances</h3>
        {loading ? <div>Chargement...</div> : (
          <div className="slot-stack">
            {split.validated.map((s, i) => (
              <PlanningSlotViewer key={i} date={s.date} userId={s.clientId} userName={s.clientName} state={s.state} address={s.location.description} isClient={true} />
            ))}
          </div>
        )}
      </section>

      <section className="panel">
        <h3>En attente de validation</h3>
        <div className="slot-stack">
          {split.validating.map((s, i) => (
            <PlanningSlotViewer key={i} date={s.date} userId={s.clientId} userName={s.clientName} state={s.state} address={s.location.description} isClient={true} />
          ))}
        </div>
      </section>

      <section className="panel">
        <h3>Seances passees</h3>
        <div className="slot-stack">
          {split.passed.map((s, i) => (
            <PlanningSlotViewer key={i} date={s.date} userId={s.clientId} userName={s.clientName} state={s.state} address={s.location.description} isClient={true} />
          ))}
        </div>
      </section>
    </div>
  );
};
